import { QueryClient, QueryClientProvider } from "react-query";
import { Routes } from "./components/App/Routes/Routes";
import { PageContentProvider } from "./contexts/PageContentProvider";
import { AuthProvider } from "./contexts/AuthContext";
import { A2HSProvider } from "./contexts/A2HSContext";
import { GlobalFilterProvider } from "./contexts/GlobalFilterProvider";

const queryClient = new QueryClient();

function AdEPorto() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <A2HSProvider>
            <PageContentProvider>
              <GlobalFilterProvider>
                {/* <MapProvider> */}
                  <Routes />
                {/* </MapProvider> */}
              </GlobalFilterProvider>
            </PageContentProvider>
          </A2HSProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}

export default AdEPorto;
